import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_SINHROPEREVOD: IWhereUsedSectionTab[] = [
    {
        title: 'Конференции',
        image: '/assets/images/usage/sinhroperevod/jpg-png/performance.jpg',
        image_webp: '/assets/images/usage/sinhroperevod/webp/performance.webp',
        text: `
            <p>При участии в&nbsp;мероприятии иностанных гостей или спикеров необходимо обеспечить синхронный перевод от&nbsp;выступающих к&nbsp;слушателям.</p>
            <p>Оборудование SPBAUDIO позволяет обслуживать мероприятия на&nbsp;2, 3&nbsp;и&nbsp;более языков.</p>
            <p>Для этого необходимо устанавливать в&nbsp;зале отдельные кабины переводчиков для каждой пары переводчиков.</p>
            `,
    },
    {
        title: 'Переговоры',
        image: '/assets/images/usage/conference-system/jpg-png/speech.png',
        image_webp: '/assets/images/usage/conference-system/webp/speech.webp',
        text: `
                <p>При важных переговорах на&nbsp;нескольких языках, необходимо исключить долгие паузы на&nbsp;перевод друг другу.</p>
                <p>Для этого используются персональные наушники с&nbsp;приемниками, куда направляется голос переводчиков, сидящих отдельно в&nbsp;звукоизолированной кабине.</p>
                <p>Такая система обеспечит максимальный комфорт и&nbsp;полное взаимопонимание между участниками дискуссии.</p>
            `,
    },
    {
        title: 'Лекции',
        image: '/assets/images/usage/sinhroperevod/jpg-png/performance-2.jpg',
        image_webp:
            '/assets/images/usage/sinhroperevod/webp/performance-2.webp',
        text: `
                <p>Если лекцию ведет иностранный докладчик, либо в&nbsp;зале присутствуют представители разных языков, необходимо использовать систему для синхронного перевода SPBAUDIO.</p>
                <p>Для этого всем участникам выдаются персональные приемники с&nbsp;наушниками, куда транслируется беспроводным способом голос переводчиков из&nbsp;специально оборудованной кабины, которая может находиться даже в&nbsp;другом помещении.</p>
            `,
    },
    {
        title: 'Театры',
        image: '/assets/images/usage/sinhroperevod/jpg-png/theater.png',
        image_webp: '/assets/images/usage/sinhroperevod/webp/theater.webp',
        text: `
                <p>Спектакли на&nbsp;иностранном языке набирают популярность, в&nbsp;том числе и&nbsp;из-за технического прогресса&nbsp;&mdash; ведь теперь при использовании системы для синхронного перевода SPBAUDIO стирается языковой барьер между зрителем и&nbsp;артистами.</p>
                <p>Удобней всего приготовить заранее текст перевода на&nbsp;нужном языке и&nbsp;просто надиктовывать его в&nbsp;гарнитуру переводчика, сидя в&nbsp;отдельной кабине, либо в&nbsp;аппаратной звукорежиссера.</p>
                <p>При этом, количество языков может быть несколько, для чего требуется только поставить дополнительные пульты SPBAUDIO MAX и&nbsp;кабины, либо развести дикторов/переводчиков в&nbsp;разные помещения.</p>
            `,
    },
    {
        title: 'Университеты',
        image: '/assets/images/usage/sinhroperevod/jpg-png/rzd-lecture.jpg',
        image_webp: '/assets/images/usage/sinhroperevod/webp/rzd-lecture.webp',
        text: `
                <p>Использование в&nbsp;системе обучения опыта иностранных специалистов, студентов или спикеров становится нормой в&nbsp;эпоху глобализации.</p>
                <p>Система синхронного перевода SPBAUDIO позволяет осуществить беспроводную передачу сигнала переводчиков в&nbsp;наушники всем учащимся, вне зависимости от&nbsp;размера аудитории.</p>
            `,
    },
    {
        title: 'Медицина',
        image: '/assets/images/usage/sinhroperevod/jpg-png/medicine.png',
        image_webp: '/assets/images/usage/sinhroperevod/webp/medicine.webp',
        text: `
                <p>При проведении онлайн-трансляции операции в&nbsp;исполнении иностранных врачей с&nbsp;целью обучения и&nbsp;развития сложных областей медицины, требуется обеспечить качественный синхронный перевод.</p>
                <p>Наша система для синхронного перевода SPBAUDIO многократно с&nbsp;успехом использовалась для подобных целей, подробности можно найти в&nbsp;портфолио.</p>
            `,
    },
    {
        title: 'Онлайн мероприятия',
        image: '/assets/images/usage/sinhroperevod/jpg-png/sinhroperevod-in-translation-booth-3.jpg',
        image_webp:
            '/assets/images/usage/sinhroperevod/webp/sinhroperevod-in-translation-booth-3.webp',
        text: `
                <p>При проведении многоязыковых мероприятий с&nbsp;использованием онлайн-платформ, переводчику не&nbsp;обязательно находиться в&nbsp;помещении.</p>
                <p>Но&nbsp;необходимо обеспечить распространение беспроводного сигнала в&nbsp;наушники оффлайн слушателей в&nbsp;зале.</p>
                <p>Для этого ноутбук коммутируется с&nbsp;передатчиками нашей системы синхронного перевода, а&nbsp;посетителям раздаются приемники с&nbsp;наушниками.</p>
                <p>Также возможно объединение работы переводчиков как в&nbsp;зале в&nbsp;изолированной кабине, так и&nbsp;онлайн.</p>
                <p>Гибкость коммутации пультов SPBAUDIO MAX позволяют это сделать.</p>
            `,
    },
]

export default WHERE_USED_SINHROPEREVOD
